module.exports = {
  /**
   * 最下部スクロールイベント.
   * ※注意： '更に読み込む' ボタン等に 'next-page-search-btn' クラスを付与してください.
   */
  scrollBottomSearchEvent(callback, callbackParam, nextPageElem) {
    let block = true;
    let body = null;
    // イベント削除
    this.scrollBottomSearchEventRemove();
    // ロード
    let didRender = function() {
      body = document.getElementsByTagName("body")[0];
    };
    // スクロール
    let onScroll = function() {
      if (body === null || body === undefined) {
        didRender();
      } else {
        // 最下部に達した場合
        let target = /BackCompat/i.test(document.compatMode)
          ? document.body
          : document.documentElement;
        let scrollTop = window.pageYOffset || target.scrollTop;
        if (target.scrollHeight - scrollTop <= target.clientHeight + 100) {
          // 更に読み込むボタンがある場合
          if (document.querySelectorAll(nextPageElem).length > 0) {
            if (block) {
              block = false;
              callback(callbackParam);
            }
          }
        } else {
          block = true;
        }
      }
    };
    window.scrollBottomSearchDidRender = function() {
      didRender();
    };
    window.scrollBottomSearchOnScroll = function() {
      onScroll();
    };
    window.addEventListener("load", window.scrollBottomSearchDidRender, false);
    window.addEventListener("scroll", window.scrollBottomSearchOnScroll, false);
  },
  /**
   * 最下部スクロールイベント削除.
   */
  scrollBottomSearchEventRemove() {
    if (window.scrollBottomSearchDidRender) {
      window.removeEventListener(
        "load",
        window.scrollBottomSearchDidRender,
        false
      );
    }
    if (window.scrollBottomSearchOnScroll) {
      window.removeEventListener(
        "scroll",
        window.scrollBottomSearchOnScroll,
        false
      );
    }
  }
};
